module.exports = __webpack_public_path__ + "media/images/logo/Logo(H)_White-5ae03ccfb3d0bfbda89e001e64905f84.png";